export default __webpack_public_path__ + "static/media/img-gtl-swp.744317db.png";